class productMultiSection {
  constructor() {
    this.init();
  }
  init = () => {
    this.ingredientSlider();
    this.clickEvents();
  };
  clickEvents = () => {
    let play = qsa(".how-to-use-video .initial-img",this.parent);
    if(play.length > 0) {
      play.forEach(item => {
        item.addEventListener("click",e => {
          item.parentNode.querySelector(".how-to-use-iframe").classList.remove("d-none");
          item.classList.add("d-none");
        })
      });
    }
  }
  ingredientSlider = () => {
    if (screen.width < 768) {
      let swiper = new Swiper(".ingredient-slider-js", {
        slidesPerView: 1.4,
        spaceBetween: 20,
      });
    }
  };
}
if(qs(".product-multi-section-js")) {
  new productMultiSection();
}